<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <ValidationObserver ref="newContractForm">
        <div class="container col-lg-6 col-sm-12">
          <ValidationProvider
            class="col-6"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              v-model="name"
              :error-messages="getErrorMessages(errors)"
              label="Name"
            />
          </ValidationProvider>
          <div class="detail-title">
            Files
          </div>
          <div class="mt-4">
            <FileUpload
              class="mt-2"
              @unselectFile="unselectFile"
              :showValidationErrors="showValidationErrors"
              @selectFile="selectFile"
              :files="files"
              :fileTypes="['application/pdf']"
              disableAutoProceed
              customActions
            />
          </div>
        </div>
      </ValidationObserver>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleAdd" :loading="isLoading">
        Add Contract
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import FileUpload from "@/components/common/FileUpload";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { first, size } from "lodash";
import {
  ADD_CONTRACT_TO_OFFER,
  FETCH_CURRENT_OFFER,
  REQUEST_SIGN_OFFER_CONTRACT
} from "@/store/modules/offers/actions";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import HelloSign from "hellosign-embedded";
import { addSuccessMessage } from "@/services/utils";

const client = new HelloSign();

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  components: {
    DialogFull,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider,
    FileUpload
  },
  data() {
    return {
      uppyInstance: null,
      showValidationErrors: false,
      isLoading: false,
      dialogSettings: {
        dialog: true,
        title: "New Contract"
      },
      files: [],
      name: ""
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      addContract: ADD_CONTRACT_TO_OFFER,
      fetchCurrentOffer: FETCH_CURRENT_OFFER,
      requestSignOfferContract: REQUEST_SIGN_OFFER_CONTRACT
    }),
    launchHelloSign({ claimUrl, contractId }) {
      client.open(claimUrl, {
        clientId: process.env.VUE_APP_HELLO_SIGN_CLIENT_ID,
        skipDomainVerification: true
      });
      client.once("send", async () => {
        this.isLoading = true;
        await this.requestSignOfferContract(contractId);
        this.isLoading = false;
        this.close();
      });
      client.once("close", async () => {
        this.close();
      });
    },
    getContractData() {
      const formData = new FormData();
      formData.append("file", first(this.files).data);
      formData.append("displayName", this.name);
      return formData;
    },
    async handleAdd() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.newContractForm.validate();
      if (isValid && size(this.files)) {
        this.isLoading = true;
        const { data: responseData } = await this.addContract({
          offerId: this.currentOfferId,
          data: this.getContractData()
        });
        if (responseData) {
          const {
            data: {
              id,
              links: { claimUrl }
            }
          } = responseData;
          this.launchHelloSign({ claimUrl, contractId: id });
          addSuccessMessage();
          this.isLoading = false;
        }
      }
    },
    close() {
      this.fetchCurrentOffer(this.currentOfferId);
      this.$emit("close");
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    selectFile({ uppyInstance, file }) {
      this.uppyInstance = uppyInstance;
      this.files.push(file);
    },
    unselectFile({ uppyInstance }) {
      this.files = [];
      uppyInstance.reset();
    }
  }
};
</script>

<style lang="scss"></style>
